<template>
  <div class="parking-dashboard" style="background: linear-gradient(135deg, #0A1A3A 0%, #0C2D5A 100%)">
    <!-- 头部区域 -->
    <div class="dashboard-header">
      <!-- 全屏按钮 -->
      <button
          class="fullscreen-btn"
          style="position: absolute; top: 20px; left: 20px"
          @click="toggleFullScreen"
          :title="isFullScreen ? '退出全屏' : '进入全屏'"
      >
        <i class="fas" :class="isFullScreen ? 'fa-compress' : 'fa-expand'"></i>
        <span>{{ isFullScreen ? '退出全屏' : '全屏查看' }}</span>
      </button>
      <h1 style="padding-top: 20px"><i class="fas fa-parking"></i> 智慧停车场数据大屏</h1>
      <div class="subtitle">实时监控停车场道闸、月卡、充电桩及摄像头数据</div>

      <div class="datetime">{{ currentDatetime }}</div>
    </div>

    <!-- 主体容器 -->
    <div class="dashboard-container">
      <!-- 左侧面板 -->
      <div class="left-panel">
        <!-- 停车场概览 -->
        <div class="panel">
          <h3><i class="fas fa-parking"></i> 停车场概览</h3>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalMoney }}</div>
              <div class="stat-label">平台总收入(元)</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalUser }}</div>
              <div class="stat-label">平台总用户(人)</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalPackingOrderMoney }}</div>
              <div class="stat-label">停车场总收入(元)</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalPackingOrder }}</div>
              <div class="stat-label">停车场总订单(笔)</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalChargeMoney }}</div>
              <div class="stat-label">充电总收入(元)</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ packing.totalChargeOrder }}</div>
              <div class="stat-label">充电总订单(笔)</div>
            </div>
          </div>
        </div>

        <!-- 月卡管理 -->
        <!--        <div class="panel">-->
        <!--          <h3><i class="fas fa-id-card"></i> 月卡管理</h3>-->
        <!--          <div class="monthly-stats">-->
        <!--            <div class="monthly-item">-->
        <!--              <span>有效月卡数</span>-->
        <!--              <strong>{{ activeCards }}</strong>-->
        <!--            </div>-->
        <!--            <div class="monthly-item">-->
        <!--              <span>本月到期</span>-->
        <!--              <strong class="warning">{{ expiringCards }}</strong>-->
        <!--            </div>-->
        <!--            <div class="monthly-item">-->
        <!--              <span>月卡使用率</span>-->
        <!--              <strong>{{ cardUsageRate }}</strong>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="chart-container">-->
        <!--            <div ref="monthlyTrendChart" style="width:100%; height:200px;"></div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- 道闸实时数据 -->
        <div class="panel">
          <h3><i class="fas fa-traffic-light"></i> 道闸实时数据</h3>
          <div class="gate-stats">
            <div class="gate-stat">
              <div class="gate-name">入口1</div>
              <div
                  class="gate-status"
                  :class="{ open: gate1Status === '开启', closed: gate1Status === '关闭' }"
              >
                {{ gate1Status }}
              </div>
              <div class="gate-count">
                今日通过：<strong>{{ gate1Count }}</strong>辆
              </div>
            </div>
            <!--            <div class="gate-stat">-->
            <!--              <div class="gate-name">出口1</div>-->
            <!--              <div-->
            <!--                  class="gate-status"-->
            <!--                  :class="{ open: gate2Status === '开启', closed: gate2Status === '关闭' }"-->
            <!--              >-->
            <!--                {{ gate2Status }}-->
            <!--              </div>-->
            <!--              <div class="gate-count">-->
            <!--                今日通过：<strong>{{ gate2Count }}</strong>辆-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="gate-stat">
              <div class="gate-name">入口2</div>
              <div
                  class="gate-status"
                  :class="{ open: gate3Status === '开启', closed: gate3Status === '关闭' }"
              >
                {{ gate3Status }}
              </div>
              <div class="gate-count">
                今日通过：<strong>{{ gate3Count }}</strong>辆
              </div>
            </div>
          </div>

          <!-- 实时通行记录 -->
          <div class="passing-records">
            <h4 style="color: #fff"><i class="fas fa-list-alt"></i> 实时通行记录({{ packingOrderList.length }})</h4>
            <div class="records-list">
              <div
                  v-for="(record, index) in packingOrderList"
                  :key="index"
                  class="record-item"
                  :class="record.direction"
              >
                <div style="display: flex; justify-content: space-between;">
                  <span class="time" style="width: 160px">{{ record.inParkTime }}</span>
                  <span class="plate" style="color: #fff">{{ record.plateNumber }}</span>
                  <span class="gate" style="color: #fff">{{ record.inParkChannelName }}</span>
                  <span
                      class="type"
                      style="display: flex; align-items: center"
                      :class="{ monthly: record.plateTypeStr === '月租车', temp: record.plateTypeStr !== '月租车' }"
                  >
                  {{ record.plateTypeStr === '月租车' ? '月租车' : '临时车' }}
                </span>
                </div>
                <div style="color: #ffffff">停车场：{{ record.siteName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间面板 -->
      <div class="middle-panel">
        <!-- 实时视频监控 -->
        <div class="panel">
          <div style="display: flex; justify-content: space-between">
            <h3 style="min-width: 180px"><i class="fas fa-video"></i> 实时视频监控</h3>
            <div class="camera-selector">
              <button
                  class="camera-btn"
                  v-for="(item, index) in videoList"
                  :key="index"
                  @click="videoClick(item)"
                  :class="{ active: currentCameraKey === item.id }"
              >
                {{ item.name }}
              </button>
            </div>
          </div>
          <div id="container"></div>
        </div>
        <!-- 报警与异常 -->
        <div class="panel">
          <h3><i class="fas fa-exclamation-triangle"></i> 实时报警</h3>
          <div class="alerts-list">
            <div
                v-for="(alert, index) in alerts"
                :key="index"
                class="alert-item"
                :class="alert.level"
            >
              <span class="alert-time">{{ alert.time }}</span>
              <span class="alert-content" style="color: #fff">{{ alert.content }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧面板 -->
      <div class="right-panel">


        <!-- 充电桩状态 -->
        <div class="panel">
          <h3><i class="fas fa-charging-station"></i> 充电桩状态</h3>
          <div class="charging-summary" style="margin-bottom: 10px">
            <div class="summary-item">
              <span>在线桩数</span>
              <strong style="color: #fff">{{ freePile }}/{{ pileList.length }}</strong>
            </div>
            <div class="summary-item">
              <span>使用中</span>
              <strong style="color: #fff">{{ chargePile }}</strong>
            </div>
            <div class="summary-item">
              <span>故障数</span>
              <strong class="error">{{ faultPile }}</strong>
            </div>
          </div>
          <div class="charging-grid">
            <!-- 充电桩卡片 -->
            <div
                v-for="charger in pileList"
                :key="charger.id"
                class="charger-card"
                :class="charger.status"
            >
              <div class="charger-header">
                <span style="color: #fff">{{ charger.name }}</span>
                <span
                    class="status-dot"
                    :class="{
                    green: charger.status === 'free',
                    orange: charger.status === 'charge',
                    red: charger.status === 'fault'
                  }"
                ></span>
                <!--                :class="{ pulse: charger.status === 'in-use' }"-->

              </div>
              <div class="charger-body">
                <div v-for="(item, index) in pileType" :key="index" v-if="item.value == charger.type">类型：{{ item.label }}</div>
                <div>功率：{{ charger.power }}</div>
                <div>电流：{{ charger.elect }}</div>
                <div v-if="charger.status === 'free'" class="charging-time">空闲</div>
                <div v-if="charger.status === 'charge'" class="charging-time" style="color: #f6ad55">充电中</div>
                <div v-if="charger.status === 'fault'" class="charging-time" style="color: #f56565">故障</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import request from '../../utils/request'; // 引入封装的axios请求
import "ezuikit-flv/style.css";
import EzuikitFlv from "ezuikit-flv";
import * as echarts from 'echarts'; // 若使用Vue CLI，需先安装：npm install echarts@5.4.3

export default {
  name: 'FlvPlayer',
  data() {
    return {
      // 新增全屏状态标识
      isFullScreen: false,
      player: {},
      // 摄像头数据
      currentCameraKey: '',
      videoList: [],
      packing: {
        totalMoney: 0, // 平台合计总收入
        totalUser: 0, // 平台合计总用户
        totalPackingOrder: 0, // 停车场停车合计订单总数
        totalChargeMoney: 0, // 充电平台合计总收入
        totalChargeOrder: 0, // 充电平台合计总订单
        totalPackingOrderMoney: 0, // 停车场停车总收入
        dayNewMoneyParking: 0, // 今日当前收益
        dayNewPackingOrder: 0, // 今日停车订单
        packingOrder: 0, // 当前停车数量
      },
      pileList: [{
        name: '',
        type: '',
        status: '',
        power: '',
        elect: ''
      }],
      chargePile: 0,
      faultPile: 0,
      freePile: 0,
      pileType: [],
      packingOrderList: [{
        inParkTime: '',
        plateNumber: '',
        inParkChannelName: '',
        siteName: '',
        plateTypeStr: ''
      }],

      // 停车场概览数据
      totalSpaces: 356,
      occupiedSpaces: 287,
      freeSpaces: 69,
      usageRate: '80.6%',

      // 月卡数据
      activeCards: '245张',
      expiringCards: '32张',
      cardUsageRate: '68.5%',
      cameraNames: {
        entrance1: '入口1摄像头',
        exit1: '出口1摄像头',
        b1: 'B1层摄像头',
        charging: '充电区摄像头',
        elevator: '电梯厅摄像头'
      },

      // 充电桩数据
      onlineChargers: '8/10',
      inUseChargers: 3,
      faultChargers: 1,
      chargers: [
        {id: 'A01', type: '快充', power: '60kW', current: '120A', status: 'available', time: '空闲'},
        {id: 'A02', type: '快充', power: '60kW', current: '120A', status: 'in-use', time: '已用45min'},
        {id: 'A03', type: '慢充', power: '7kW', current: '32A', status: 'fault', time: '故障'},
        {id: 'A04', type: '慢充', power: '7kW', current: '32A', status: 'available', time: '空闲'},
        {id: 'B01', type: '快充', power: '120kW', current: '250A', status: 'in-use', time: '已用28min'},
        {id: 'B02', type: '快充', power: '120kW', current: '250A', status: 'in-use', time: '已用15min'},
        {id: 'B03', type: '慢充', power: '7kW', current: '32A', status: 'available', time: '空闲'},
        {id: 'B04', type: '慢充', power: '7kW', current: '32A', status: 'available', time: '空闲'},
        {id: 'C01', type: '快充', power: '60kW', current: '120A', status: 'available', time: '空闲'},
        {id: 'C02', type: '快充', power: '60kW', current: '120A', status: 'available', time: '空闲'},
        {id: 'C03', type: '快充', power: '60kW', current: '120A', status: 'available', time: '空闲'},
        {id: 'C04', type: '快充', power: '60kW', current: '120A', status: 'available', time: '空闲'}
      ],

      // 道闸数据
      gate1Status: '开启',
      gate2Status: '关闭',
      gate3Status: '开启',
      gate1Count: 245,
      gate2Count: 198,
      gate3Count: 178,

      // 通行记录
      passingRecords: [
        {time: '14:30:22', plate: '京A·12345', gate: '入口1', type: 'temp', direction: 'in'},
        {time: '14:28:15', plate: '京B·67890', gate: '出口2', type: 'monthly', direction: 'out'},
        {time: '14:25:47', plate: '京C·AB123', gate: '入口2', type: 'monthly', direction: 'in'},
        {time: '14:22:33', plate: '京D·CD456', gate: '出口1', type: 'temp', direction: 'out'},
        {time: '14:20:18', plate: '京E·EF789', gate: '入口1', type: 'monthly', direction: 'in'},
        {time: '14:18:05', plate: '京F·GH012', gate: '出口2', type: 'temp', direction: 'out'},
        {time: '14:15:52', plate: '京G·IJ345', gate: '入口2', type: 'monthly', direction: 'in'},
        {time: '14:12:39', plate: '京H·KL678', gate: '出口1', type: 'monthly', direction: 'out'}
      ],

      // 报警数据
      alerts: [
        {time: '14:25:10', content: '充电桩A03过载保护', level: 'critical'},
        {time: '14:20:33', content: '入口道闸开合异常', level: 'warning'},
        {time: '14:15:47', content: '月卡余额不足提醒（5张）', level: 'info'},
        {time: '14:10:22', content: '摄像头B1层离线', level: 'warning'},
      ],

      // 时间相关
      currentDatetime: '',
      currentTime: '',

      // 定时器
      timer: null,
      gateStatusTimer: null
    };
  },
  mounted() {

    this.initData();

    // 初始化时间
    this.updateDateTime();

    // 初始化图表
    // this.initCharts();

    // 启动实时更新
    this.simulateRealTimeUpdates();

    // 监听窗口大小变化
    window.addEventListener('resize', this.resizeChart);

    // 新增：监听全屏状态变化事件
    document.addEventListener('fullscreenchange', this.handleFullScreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullScreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullScreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullScreenChange);
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer);
    clearInterval(this.gateStatusTimer);

    // 移除事件监听
    window.removeEventListener('resize', this.resizeChart);
    // 新增：移除全屏状态监听
    document.removeEventListener('fullscreenchange', this.handleFullScreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullScreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullScreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullScreenChange);
  },
  methods: {
    async videoClick(item) {
      console.log('---- videoClick ----', item)
      if (this.player) {
        try {
          if (this.player.pause) {
            this.player.pause();
          }
          // this.player.destroyed = true; // 销毁播放器
          // this.player = null; // 清空实例
          // 清空播放容器（可选，防止残留画面）
          const container = document.getElementById('container');
          if (container) {
            container.innerHTML = '';
          }
          this.player = null;
          console.log('---- videoClick1 ----', this.player)
        } catch (e) {
          console.warn('销毁播放器失败：', e);
        }
      }
      this.currentCameraKey = item.id
      const res = await request({
        url: '/app/video/getWebUrl?id=' + item.id,
        method: 'get'
      });
      this.player = new EzuikitFlv({
        url: res, // https://play.com/9999.flv
        id: "container", // support element id
        decoder: "decoder.js", // 自定义解码库加载地址， 默认放置在服务器根目录下
        autoPlay: true,
        width: '100%',
        // useMSE: true,
        // themeData: null // 忽略主题
      });

      console.log('player------', this.player)
    },
    async initData() {
      console.log('------------------- initData -------------------')
      const res = await request({
        url: '/app/video/getAllVideo',
        method: 'get'
      });
      this.videoList = res

      this.videoClick(this.videoList[0])

      const data = await request({
        url: '/app/bigData/getData',
        method: 'get'
      });

      this.packing.totalPackingOrderMoney = data['totalPackingOrderMoney']
      this.packing.dayNewMoneyParking = data['dayNewMoney_parking']
      this.packing.dayNewPackingOrder = data['dayNewPackingOrder']
      this.packing.totalMoney = data['totalMoney']
      this.packing.totalUser = data['totalUser']
      this.packing.totalPackingOrderMoney = data['totalPackingOrderMoney']
      this.packing.totalPackingOrder = data['totalPackingOrder']
      this.packing.totalChargeMoney = data['totalChargeMoney']
      this.packing.totalChargeOrder = data['totalChargeOrder']
      this.packing.packingOrder = data['packingOrder'].length
      this.packingOrderList = data['packingOrder']
      this.pileList = data['pileList']
      this.chargePile = data['chargePile']
      this.faultPile = data['faultPile']
      this.freePile = data['freePile']
      this.pileType = data['pileType']
      console.log('------------------- videoList: ', this.videoList)
    },
    // 新增全屏切换方法
    toggleFullScreen() {
      // 判断当前是否处于全屏状态
      if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
        // 进入全屏
        const element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) { // Chrome/Safari
          element.webkitRequestFullscreen();
        } else if (element.mozRequestFullScreen) { // Firefox
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) { // IE/Edge
          element.msRequestFullscreen();
        }
        this.isFullScreen = true;
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isFullScreen = false;
      }
    },

    // 监听全屏状态变化（防止用户通过快捷键切换导致状态不同步）
    handleFullScreenChange() {
      this.isFullScreen = !!document.fullscreenElement || !!document.webkitFullscreenElement || !!document.mozFullScreenElement || !!document.msFullscreenElement;
    },
    // 初始化ECharts图表
    initCharts() {
      const monthlyChart = echarts.init(this.$refs.monthlyTrendChart);
      const monthlyOption = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderColor: '#4facfe',
          textStyle: {color: '#fff'}
        },
        legend: {
          data: ['月卡数量', '月卡续费率'],
          textStyle: {color: '#a0aec0'},
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLine: {lineStyle: {color: 'rgba(255,255,255,0.2)'}},
          axisLabel: {color: '#a0aec0'}
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            axisLine: {lineStyle: {color: 'rgba(255,255,255,0.2)'}},
            axisLabel: {color: '#a0aec0'},
            splitLine: {lineStyle: {color: 'rgba(255,255,255,0.1)'}}
          },
          {
            type: 'value',
            name: '百分比',
            max: 100,
            axisLine: {lineStyle: {color: 'rgba(255,255,255,0.2)'}},
            axisLabel: {color: '#a0aec0', formatter: '{value}%'},
            splitLine: {lineStyle: {color: 'rgba(255,255,255,0.1)'}}
          }
        ],
        series: [
          {
            name: '月卡数量',
            type: 'line',
            smooth: true,
            lineStyle: {width: 4, color: '#4facfe'},
            itemStyle: {color: '#4facfe'},
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: 'rgba(79, 172, 254, 0.5)'},
                {offset: 1, color: 'rgba(79, 172, 254, 0.1)'}
              ])
            },
            data: [180, 195, 210, 230, 245, 260, 275, 290, 280, 265, 250, 240]
          },
          {
            name: '月卡续费率',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            lineStyle: {width: 4, color: '#00f2fe'},
            itemStyle: {color: '#00f2fe'},
            data: [85, 88, 90, 87, 92, 95, 93, 94, 91, 89, 88, 90]
          }
        ]
      };
      monthlyChart.setOption(monthlyOption);
      this.monthlyChart = monthlyChart; // 保存图表实例
    },

    // 调整图表大小
    resizeChart() {
      if (this.monthlyChart) {
        this.monthlyChart.resize();
      }
    },

    // 更新日期时间
    updateDateTime() {
      console.log('updateDateTime---------------------111111111111')
      const now = new Date();
      const dateStr = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`;
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      this.currentDatetime = `${dateStr} ${timeStr}`;
      this.currentTime = timeStr;
    },

    // 模拟实时数据更新
    simulateRealTimeUpdates() {
      // 每秒更新时间
      this.timer = setInterval(() => {
        this.updateDateTime();
      }, 1000);

      // 每5秒更新道闸和车位数据
      setInterval(() => {
        // 随机增加道闸计数
        const increment = Math.floor(Math.random() * 3) + 1;
        this.gate1Count += increment;

        if (Math.random() > 0.3) {
          this.gate2Count += 1;
        }

        if (Math.random() > 0.4) {
          this.gate3Count += 1;
        }

        // 更新车位数据
        const change = Math.floor(Math.random() * 3) - 1; // -1, 0, 1
        const newOccupied = Math.max(0, Math.min(this.totalSpaces, this.occupiedSpaces + change));
        this.occupiedSpaces = newOccupied;
        this.freeSpaces = this.totalSpaces - newOccupied;
        this.usageRate = ((newOccupied / this.totalSpaces) * 100).toFixed(1) + '%';

        // 偶尔添加新通行记录
        if (Math.random() > 0.7) {
          this.addNewPassingRecord();
        }

        // 偶尔添加新报警
        if (Math.random() > 0.9) {
          this.addNewAlert();
        }
      }, 5000);

      // 每10秒随机切换道闸状态
      this.gateStatusTimer = setInterval(() => {
        const gates = ['gate1Status', 'gate2Status', 'gate3Status'];
        const randomGate = gates[Math.floor(Math.random() * gates.length)];
        this[randomGate] = this[randomGate] === '开启' ? '关闭' : '开启';
      }, 10000);
    },

    // 添加新通行记录
    addNewPassingRecord() {
      const directions = ['in', 'out'];
      const gates = ['入口1', '入口2', '出口1', '出口2'];
      const types = ['monthly', 'temp'];

      const direction = directions[Math.floor(Math.random() * directions.length)];
      const gate = gates[Math.floor(Math.random() * gates.length)];
      const type = types[Math.floor(Math.random() * types.length)];

      // 生成随机车牌
      const prefix = ['京', '沪', '粤', '浙', '苏'][Math.floor(Math.random() * 5)];
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const numbers = '0123456789';
      const plate = `${prefix}·${letters.charAt(Math.floor(Math.random() * 26))}${numbers.charAt(Math.floor(Math.random() * 10))}${numbers.charAt(Math.floor(Math.random() * 10))}${numbers.charAt(Math.floor(Math.random() * 10))}${numbers.charAt(Math.floor(Math.random() * 10))}`;

      const now = new Date();
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

      // 插入到顶部
      this.passingRecords.unshift({
        time: timeStr,
        plate,
        gate,
        type,
        direction
      });

      // 限制最多显示10条
      if (this.passingRecords.length > 10) {
        this.passingRecords.pop();
      }
    },

    // 添加新报警
    addNewAlert() {
      const alertTypes = [
        {content: '车牌识别系统延迟', level: 'warning'},
        {content: '网络连接波动', level: 'info'},
        {content: '充电桩B01充电完成', level: 'info'},
        {content: '临时车超时提醒', level: 'warning'}
      ];

      const alert = alertTypes[Math.floor(Math.random() * alertTypes.length)];
      const now = new Date();
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

      // 插入到顶部
      this.alerts.unshift({
        time: timeStr,
        content: alert.content,
        level: alert.level
      });

      // 限制最多显示5条
      if (this.alerts.length > 5) {
        this.alerts.pop();
      }
    }
  }
};
</script>

<style scoped>
/* 全局样式重置 */
::v-deep * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

::v-deep body {
  background: linear-gradient(135deg, #0A1A3A 0%, #0C2D5A 100%);
  color: #FFFFFF;
  min-height: 100vh;
  padding: 20px;
  overflow-x: hidden;
}

::v-deep .fa {
  font-family: "Font Awesome 6 Free";
  font-weight: 900; /* 必须加这个，6.x版本需要指定权重 */
}

::v-deep .fas {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

/* 头部样式 */
.dashboard-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.dashboard-header h1 {
  font-size: 28px;
  margin-bottom: 8px;
  background: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.dashboard-header .subtitle {
  color: #a0aec0;
  font-size: 16px;
}

.dashboard-header .datetime {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #4facfe;
}

/* 主体容器 */
.dashboard-container {
  display: flex;
  gap: 20px;
  min-height: calc(100vh - 120px);
}

.left-panel, .right-panel {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.middle-panel {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.panel:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.panel h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #4facfe;
  display: flex;
  align-items: center;
  gap: 10px;
}

.panel h3 i {
  font-size: 20px;
}

/* 概览卡片样式 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.stat-item {
  background: rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 15px;
  text-align: center;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: scale(1.03);
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

.stat-label {
  font-size: 14px;
  color: #a0aec0;
}

/* 月卡数据样式 */
.monthly-stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.monthly-item {
  text-align: center;
}

.monthly-item span {
  display: block;
  font-size: 14px;
  color: #a0aec0;
  margin-bottom: 5px;
}

.monthly-item strong {
  display: block;
  font-size: 22px;
  color: #4facfe;
}

.monthly-item .warning {
  color: #f6ad55;
}

.chart-container {
  height: 200px;
  margin-top: 15px;
}

/* 视频监控样式 */
.camera-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}


.camera-btn {
  padding: 8px 15px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.camera-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.camera-btn.active {
  background: #4facfe;
}

.video-container {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

.main-video {
  position: relative;
  width: 100%;
  height: 300px;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-video::before {
  content: "模拟视频流 (实际环境中替换为真实RTSP流)";
  position: absolute;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
}

.video-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.video-thumbnails {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
}

.thumbnail {
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
}

.thumbnail:hover {
  background: rgba(255, 255, 255, 0.2);
}

.thumbnail.active {
  border: 2px solid #4facfe;
  background: rgba(79, 172, 254, 0.2);
}

/* 充电桩样式 */
.charging-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 15px;
}

.charger-card {
  background: rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  padding: 15px;
  transition: all 0.3s ease;
}

.charger-card:hover {
  transform: translateY(-5px);
}

.charger-card.free {
  border-left: 4px solid #48bb78;
}

.charger-card.charge {
  border-left: 4px solid #f6ad55;
}

.charger-card.fault {
  border-left: 4px solid #f56565;
}

.charger-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.charger-header span:first-child {
  font-weight: bold;
  font-size: 16px;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot.green {
  background-color: #48bb78;
  box-shadow: 0 0 8px #48bb78;
}

.status-dot.orange {
  background-color: #f6ad55;
  box-shadow: 0 0 8px #f6ad55;
}

.status-dot.red {
  background-color: #f56565;
  box-shadow: 0 0 8px #f56565;
}

.charger-body {
  font-size: 13px;
  color: #a0aec0;
}

.charger-body div {
  margin-bottom: 3px;
}

.charging-time {
  color: #4facfe;
  font-weight: bold;
  margin-top: 5px;
}

.charging-summary {
  display: flex;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 15px;
}

.summary-item {
  text-align: center;
}

.summary-item span {
  display: block;
  font-size: 14px;
  color: #a0aec0;
  margin-bottom: 5px;
}

.summary-item strong {
  display: block;
  font-size: 22px;
}

.summary-item .error {
  color: #f56565;
}

/* 道闸数据样式 */
.gate-stats {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.gate-stat {
  background: rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.gate-name {
  font-weight: bold;
  font-size: 16px;
  color: #fff;
}

.gate-status {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
}

.gate-status.open {
  background: rgba(72, 187, 120, 0.2);
  color: #48bb78;
}

.gate-status.closed {
  background: rgba(245, 101, 101, 0.2);
  color: #f56565;
}

.gate-count {
  font-size: 14px;
  color: #a0aec0;
}

.gate-count strong {
  color: #4facfe;
  font-size: 18px;
}

/* 通行记录样式 */
.records-list {
  max-height: 250px;
  overflow-y: auto;
  margin-top: 10px;
}

.record-item {
  padding: 12px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.record-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.record-item.in {
  border-left: 4px solid #48bb78;
}

.record-item.out {
  border-left: 4px solid #4facfe;
}

.record-item .time {
  color: #a0aec0;
  font-size: 13px;
  width: 70px;
}

.record-item .plate {
  font-weight: bold;
  width: 100px;
}

.record-item .gate {
  width: 70px;
}

.record-item .type {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.record-item .type.monthly {
  background: rgba(72, 187, 120, 0.2);
  color: #48bb78;
}

.record-item .type.temp {
  background: rgba(246, 173, 85, 0.2);
  color: #f6ad55;
}

/* 报警样式 */
.alerts-list {
  margin-top: 10px;
}

.alert-item {
  display: flex;
  padding: 12px 15px;
  border-radius: 8px;
  margin-bottom: 10px;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
}

.alert-item:hover {
  transform: translateX(5px);
}

.alert-item.critical {
  background: rgba(245, 101, 101, 0.2);
  border-left: 4px solid #f56565;
}

.alert-item.warning {
  background: rgba(246, 173, 85, 0.2);
  border-left: 4px solid #f6ad55;
}

.alert-item.info {
  background: rgba(79, 172, 254, 0.2);
  border-left: 4px solid #4facfe;
}

.alert-time {
  font-size: 13px;
  color: #a0aec0;
  width: 70px;
}

.alert-content {
  flex: 1;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .dashboard-container {
    flex-direction: column;
  }

  .left-panel, .middle-panel, .right-panel {
    width: 100%;
  }

  .charging-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .charging-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .video-thumbnails {
    grid-template-columns: repeat(2, 1fr);
  }

  .dashboard-header .datetime {
    position: static;
    margin-top: 10px;
  }
}

/* 滚动条样式 */
::v-deep ::-webkit-scrollbar {
  width: 6px;
}

::v-deep ::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #4facfe;
  border-radius: 10px;
}

::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #00f2fe;
}

/* 动画效果 */
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.pulse {
  animation: pulse 2s infinite;
}

/* 加载状态 */
.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, .3);
  border-radius: 50%;
  border-top-color: #4facfe;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

#container {
  height: 400px;
  width: 100%;
}

/* 头部操作区布局 */
.header-actions {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* 全屏按钮样式 */
.fullscreen-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(79, 172, 254, 0.2);
  border: 1px solid rgba(79, 172, 254, 0.5);
  border-radius: 8px;
  color: #4facfe;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
}

.fullscreen-btn:hover {
  background: rgba(79, 172, 254, 0.4);
  transform: translateY(-2px);
}

.fullscreen-btn i {
  font-size: 16px;
}

/* 响应式适配：小屏幕下调整按钮显示 */
@media (max-width: 768px) {
  .header-actions {
    position: static;
    margin-top: 15px;
    justify-content: center;
  }

  .fullscreen-btn span {
    display: none; /* 小屏幕隐藏文字，只显示图标 */
  }

  .fullscreen-btn {
    padding: 8px 12px;
  }
}

/* 修正原有时间样式（因为现在放在header-actions里） */
.dashboard-header .datetime {
  font-size: 18px;
  font-weight: bold;
  color: #4facfe;
  margin-right: 10px;
}
</style>
